module.exports = __webpack_public_path__ + "img/bgs.307d07e2.png";